import { CtaSidebarBlockProps } from "/Models/Generated/CTASidebarBlockProps";
import "./CtaSidebarBlock.scss";
import { InfobotAITeaser } from "/App.Components";

const CtaSidebarBlock = (props: CtaSidebarBlockProps) => {
  if (!props.cta) {
    return null;
  }
  return (
    <div className="cta-sidebar-block">
      <InfobotAITeaser {...props.cta} />
    </div>
  );
};

export default CtaSidebarBlock;
